themeBase.requestIdleCallback(() => {
  window.toggleCartCheckoutConfirmation = function() {
    const ctasButton = document.querySelector('.cart__ctas button');
    const dynamicCheckoutButtons = document.querySelector('.cart__dynamic-checkout-buttons');

    ctasButton[this.checked ? 'removeAttribute' : 'setAttribute']('disabled', true);

    if (dynamicCheckoutButtons) {
      dynamicCheckoutButtons.classList[this.checked ? 'remove' : 'add']('cart__dynamic-checkout-buttons--disabled');
    }
  };
});